// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cc3aefb6","787":"a23aac90","950":"76ee7a3e"}[chunkId] + ".chunk.js";
};